import { useEffect, useContext } from "react";
import { getApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import { AxiosResponse } from "axios";
import * as mb from "views/common/MessageBox";
import { postApiDataWithToken } from "views/utils/CallApi";
import { getRef } from "../../../utils/InputHelp";
import { useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import * as MessageBox from "../../../common/MessageBox";
import * as Validation from "../../../utils/Validation";

interface IFReservationHistory {
    reservableStartDate: number,
    reservableEndDate: number
}

export function Reservation(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [reservationHistory, setReservationHistory] = useState<IFReservationHistory[]>();
    const reservableStartDate = useRef<HTMLInputElement>(null);
    const reservableEndDate = useRef<HTMLInputElement>(null);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);

    useEffect(function(){ 
        //初期値取得
        const rsHistory:IFReservationHistory[] = [];

        getApiDataWithToken('/management/settings/system',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        rsHistory.push({reservableStartDate:res.data.system_list[0].reservable_start_date, reservableEndDate:res.data.system_list[0].reservable_end_date});
                        setReservationHistory(rsHistory);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function clickSubmit(){
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);
        
        //バリデーションチェック
        let errmsg:string;
        //空チェック
        errmsg = Validation.checkEmptyTextBox(getRef(reservableStartDate), "予約受付開始日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);            
            return false;
        }
        errmsg = Validation.checkEmptyTextBox(getRef(reservableEndDate), "予約受付終了日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);            
            return false;
        }
        //整数チェック
        errmsg = Validation.checkPositiveInteger(Number(getRef(reservableStartDate)), "予約受付開始日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);            
            return false;
        }
        errmsg = Validation.checkPositiveInteger(Number(getRef(reservableEndDate)), "予約受付終了日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        //数値範囲チェック
        errmsg = Validation.checkRangeNumber(Number(getRef(reservableStartDate)), 0, 90, "予約受付開始日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkRangeNumber(Number(getRef(reservableEndDate)), 1, 180, "予約受付終了日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        //開始期間終了期間整合性チェック
        errmsg = Validation.checkReversalTerm(Number(getRef(reservableStartDate)), Number(getRef(reservableEndDate)), "予約受付開始日", "予約受付終了日")
        if (errmsg) {
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //入力値取得
        postApiDataWithToken('/management/settings/reservable',
            {'reservable_start_date': getRef(reservableStartDate),'reservable_end_date': getRef(reservableEndDate)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"予約設定が完了しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"予約設定に失敗しました。"});
                }
                //ボタンを活性にする
                setSubmitDisabled(false);
            }
        );

    }


    return (
        <AdminFrame>
            <div className="contents">
                <MessageBox.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">予約設定</h2>
                <div className="settings-wrap-short">
                    <div className="settings-block">
                        <h3 className="settings-title-h3">予約受付日指定</h3>
                        {reservationHistory?.map(function(val, idx){
                            return(
                                <div className="settings-form" key={idx}>
                                    <div className="form-row">
                                        <div className="form-row-title">予約受付開始日</div>
                                        <div className="form-row-comment">
                                            何日後から予約の受付を可能にするかの設定です。<br/>例えば、注文日の3日後から予約可能な場合は、「3」を入力してください。<br/>（設定可能範囲：0 ～ 90）
                                        </div>
                                        <div className="form-row-input"><input required type="number" ref={reservableStartDate} defaultValue={val.reservableStartDate} min="0" className="m-input-text input-size-ss"/></div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-row-title">予約受付終了日</div>
                                        <div className="form-row-comment">
                                            何日後まで予約の受付を可能にするかの設定です。<br/>例えば、注文日から90日後まで予約可能な場合は、「90」を入力してください。<br/>（設定可能範囲：1 ～ 180）
                                        </div>
                                        <div className="form-row-input"><input required type="number" ref={reservableEndDate} defaultValue={val.reservableEndDate} min="0" className="m-input-text input-size-ss"/></div>
                                    </div>
                                </div>
                            )
                        })}                        
                    </div>
                    <button className="btn-primary margin-tb-20" onClick={clickSubmit} disabled={submitDisabled}>変更を保存</button>
                </div>
            </div>
        </AdminFrame>
    )
}